document.addEventListener('DOMContentLoaded', function() {
    const faqItems = document.querySelectorAll('.faq-teaser__faqs-list-item');
    
    // Exit early if no FAQ items found on page
    if (faqItems.length === 0) return;

    faqItems.forEach(function(item) {
        // Handle click events
        item.addEventListener('click', function() {
            handleToggle(item);
        });

        // Handle keyboard events for accessibility
        item.addEventListener('keydown', function(event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                handleToggle(item);
            }
        });
    });

    function handleToggle(item) {
        const isCurrentlyOpen = item.classList.contains('faq-teaser__faqs-list-item--open');
        
        if (isCurrentlyOpen) {
            // Close this item
            closeItem(item);
        } else {
            // Close all other items first
            faqItems.forEach(function(otherItem) {
                if (otherItem !== item) {
                    closeItem(otherItem);
                }
            });
            
            // Then open this item
            openItem(item);
        }
    }

    function openItem(item) {
        const answer = item.querySelector('.faq-teaser__faqs-list-item-answer');
        const buttonText = item.querySelector('.faq-teaser__faqs-list-item-button .sr-only');
        
        item.classList.add('faq-teaser__faqs-list-item--open');
        item.setAttribute('aria-expanded', 'true');
        
        // Add visible class for smooth animation
        answer.classList.add('is-visible');
        
        // Update button text for screen readers
        if (buttonText) {
            buttonText.textContent = 'Close';
        }
    }

    function closeItem(item) {
        const answer = item.querySelector('.faq-teaser__faqs-list-item-answer');
        const buttonText = item.querySelector('.faq-teaser__faqs-list-item-button .sr-only');
        
        item.classList.remove('faq-teaser__faqs-list-item--open');
        item.setAttribute('aria-expanded', 'false');
        
        // Remove visible class for smooth animation
        answer.classList.remove('is-visible');
        
        // Update button text for screen readers
        if (buttonText) {
            buttonText.textContent = 'Open';
        }
    }
});